import { get, put } from '../utils/request';

export const getTemplateEditorData = (templateEditorParameter) =>
  get('/api/v1/templateEditor', {}, { params: templateEditorParameter });

export const getTextElementForAdminTool = (parameter) => {
  return get('/api/v1/textElementForAdminTool', {}, { params: parameter });
};

export const updateTemplateEditorData = (textElementRequest) => {
  return put('/api/v1/textElementForAdminTool', textElementRequest);
};
